export function tabNavigation() {
	const tabGroups = document.querySelectorAll('[data-content-blocks-group]')
	if (!tabGroups.length) return

	const hash = window.location.hash

	if (hash) {
		window.history.replaceState({}, '', window.location.pathname + window.location.search)
	}

	tabGroups.forEach(group => {
		const nav = group.querySelector('[data-content-blocks-group-navigation]')
		if (!nav) return

		const tabs = group.querySelectorAll('[data-content-blocks-group-tab]')
		if (!tabs.length) return

		let activeSet = false
		
		// Check if any tab already has active class from HTML
		const hasExistingActive = Array.from(tabs).some(tab => tab.classList.contains('active'))

		tabs.forEach((tab, index) => {
			let originalId = tab.id
			if (!originalId) return

			const slug = originalId
				.trim()
				.toLowerCase()
				.replace(/[\s_]+/g, '-')
				.replace(/[^\w-]+/g, '')

			tab.id = slug

			const li = document.createElement('li')
			li.setAttribute('data-scroll-snap-menu-item', '')
			li.className = 'tab-navigation__item'

			const link = document.createElement('a')
			link.className = 'tab-navigation__link'
			link.href = `#${slug}`
			link.textContent = originalId

			// Active logic: hash match > existing HTML active class > first tab
			let isActive = false
			if (hash === `#${slug}`) {
				// Hash takes priority - remove existing active classes and set this one
				if (!activeSet) {
					tabs.forEach(t => t.classList.remove('active'))
				}
				isActive = true
			} else if (!activeSet && !hash) {
				// No hash - use existing active class or default to first tab
				if (hasExistingActive) {
					isActive = tab.classList.contains('active')
				} else {
					isActive = index === 0
				}
			}
			
			if (isActive) {
				li.classList.add('active')
				tab.classList.add('active')
				activeSet = true
			}

			link.addEventListener('click', e => {
				e.preventDefault()
				group.querySelectorAll('[data-content-blocks-group-tab]').forEach(t => t.classList.remove('active'))
				nav.querySelectorAll('[data-scroll-snap-menu-item]').forEach(l => l.classList.remove('active'))
				tab.classList.add('active')
				li.classList.add('active')
			})

			li.appendChild(link)
			nav.appendChild(li)
		})
	})
}